<template>
  <section class="page-dashbord-discusses pt-3">
    <app-loading :isFull="true" v-if="isLoading" />
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width='{1200:"60%",992:"80%",768:"90%"}'
    >
      <app-loading :isFull="false" v-if="isLoading" />
      <div v-if="isUpdateDiscuss && itemUpdate" class="pt-3">
        <div class="row">
          <div class="col-8">
            <div class="group-form">
              <input
                type="text"
                v-validate="'required'"
                name="title"
                :class="{active:itemUpdate.item.title != '' }"
                v-model="itemUpdate.item.title"
              />
              <span class="bar"></span>
              <label class="statr">عنوان سوال</label>
              <span v-if="errors.has('title')" class="is-danger">فیلد نباید خالی باشد</span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-checkbox rtl text-right">
              <div class="md-checkbox">
                <input type="checkbox" id="published" v-model="itemUpdate.item.published" />
                <label for="published" class="font-14">پابلیش</label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="group-form">
              <div class="editor rtl text-right my-4">
                <tinymce-editor
                  v-model="itemUpdate.item.content"
                  api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
                  :init="configMedia"
                ></tinymce-editor>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-action my-2">
              <button
                class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                v-ripple
                @click="updateDiscuss"
              >بروزرسانی پرسش</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="replieItem && isReplie">
        <div class="col-12">
          <div class="editor rtl text-right my-4">
            <label class="statr">جواب خود را مطرح کنید</label>
            <tinymce-editor
              v-model="replieItem.replie.content"
              api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
              :init="configMedia"
            ></tinymce-editor>
          </div>
        </div>
        <div class="col-4">
          <div class="input-checkbox rtl text-right">
            <div class="md-checkbox">
              <input type="checkbox" id="published" v-model="replieItem.replie.published" />
              <label for="published" class="font-14">پابلیش</label>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-action my-2">
            <button
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="updateReplie"
            >بروزرسانی جواب</button>
          </div>
        </div>
      </div>
    </vue-modaltor>
    <div class="container">
      <div class="row">
        <div class="col">
          <h4 class="text-right rtl font-18 mb-4">پرسش و پاسخ</h4>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="پرسش های پابلیش شده" @click="discussGet(true)">
                <discuss-list
                  @discussDelete="discussDelete"
                  @editReplies="editReplies"
                  @editDiscuss="editDiscuss"
                  :isAdmin="true"
                  v-if="listDiscuss.length"
                  class="mb-4"
                  :title="'پرسش و پاسخ های مطرح شده'"
                  :items="listDiscuss"
                  @replyDiscuss="openReplyDiscuss"
                  @getDiscussReply="getDiscussReply"
                />
              </b-tab>
              <b-tab title="پرسش های پابلیش نشده" @click="discussGet(false)">
                <discuss-list
                  @discussDelete="discussDelete"
                  @editReplies="editReplies"
                  @editDiscuss="editDiscuss"
                  :isAdmin="true"
                  v-if="listDiscuss.length"
                  class="mb-4"
                  :title="'پرسش و پاسخ های مطرح شده'"
                  :items="listDiscuss"
                  @replyDiscuss="openReplyDiscuss"
                  @getDiscussReply="getDiscussReply"
                />
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import discussList from "cp/list-discuss.vue";
export default {
  name: "page-dashbord-discusses",
  components: {
    discussList
  },
  data() {
    return {
      isLoading: true,
      isReplie: false,
      isModal: false,
      isUpdateDiscuss: false,
      itemUpdate: null,
      replieItem: null
    };
  },
  computed: {
    listDiscuss() {
      return this.$store.state.dashboardDiscusses.listDiscuss;
    }
  },
  mounted() {
    this.discussGet(true);
  },
  methods: {
    editReplies(item, index, replie, j) {
      this.isReplie = true;
      this.isModal = true;
      this.replieItem = { item, index, replie, j };
    },
    editDiscuss(item, index) {
      this.isUpdateDiscuss = true;
      this.isModal = true;
      this.itemUpdate = { item, index };
      // console.log(item, index)
    },
    async updateReplie() {
      this.isLoading = true;
      await this.$store.dispatch(
        "dashboardDiscusses/updateReplie",
        this.replieItem
      );
      this.isLoading = false;
      this.hideModal();
    },
    async discussGet(published) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardDiscusses/discussGet", {
        published
      });
      this.isLoading = false;
    },
    async discussDelete(item, index) {
      let result = window.confirm("آیا از حذف این پرسش اطمینان دارید؟");
      if (!result) return;
      this.isLoading = true;
      await this.$store.dispatch("dashboardDiscusses/discussDelete", item);
      this.isLoading = false;
      this.$delete(this.listDiscuss, index);
    },

    hideModal() {
      this.isModal = false;
      this.itemUpdate = null;
      this.replieItem = null;
      // this.activeDiscuss = {}
      // this.formDiscussReplyNew[0].model = ''
    },
    async updateDiscuss() {
      await this.$store.dispatch(
        "dashboardDiscusses/updateDiscussNew",
        this.itemUpdate
      );
      this.hideModal();
    },
    async postDiscussNew() {
      let faqForm = this.formHandeler(this.faqForm);
      faqForm.course = parseInt(this.courseId);
      await this.$store.dispatch("dashboardDiscusses/postDiscussNew", faqForm);
    },
    openReplyDiscuss(item, index) {
      this.isModal = true;
      this.activeDiscuss = { item, index };
    },
    async postDiscussReplyNew() {
      this.isLoading = true;
      let formDiscussReplyNew = this.formHandeler(this.formDiscussReplyNew);
      formDiscussReplyNew.discuss = parseInt(this.activeDiscuss.item.id);
      await this.$store.dispatch("dashboardDiscusses/discussReplyNew", {
        formDiscussReplyNew,
        index: this.activeDiscuss.index
      });
      this.isLoading = false;
      this.hideModal();
    },
    async getDiscussReply(item, index) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardDiscusses/getDiscussReplySu", {
        discuss_id: item.id,
        id:item.id
      });
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-discusses {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/discusses.vue